import React, {Component} from "react";
import RemotingService from "../../services/remoting-service/RemotingService";
import ValidationUtil from "../../components/form/validator/ValidationUtil";
import PatientUtil from "../../utils/PatientUtil";
import StringUtil from "../../utils/StringUtil";
import {Wizard} from "../../components";
import moment from "moment";
import FormLanguages from "./enum/FormLanguages";
import IntakeFormHeader from "./intakeform/IntakeFormHeader";
import IntakeFormRadTextEnum from "./intakeformrad/enum/IntakeFormRadTextEnum";
import IntakeFormRadPersonalInformation from "./intakeformrad/IntakeFormRadPersonalInformation";
import IntakeFormRadContactInformation from "./intakeformrad/IntakeFormRadContactInformation";
import IntakeFormRadReferralInformation from "./intakeformrad/IntakeFormRadReferralInformation";
import IntakeFormRadEmergencyContact from "./intakeformrad/IntakeFormRadEmergencyContact";
import IntakeFormRadHealthHistory from "./intakeformrad/IntakeFormRadHealthHistory";
import ConsentFormPartsRad from "./utils/ConsentFormPartsRad";
import InformedConsentFormRadTextEnum from "./informedconsent/enum/InformedConsentFormRadTextEnum";
import InformedConsentSignatureInputs from "./informedconsent/InformedConsentSignatureInputs";
import CancellationPolicyPartsDxb from "./cancellationpolicy/CancellationPolicyPartsDxb";
import CancellationPolicyDxbTextEnum from "./cancellationpolicy/enum/CancellationPolicyDxbTextEnum";
import NabidhConsentFormParts from "./nabidh/NabidhConsentFormParts";
import NabidhFormTextEnum from "./NabidhFormTextEnum";
import LookupService from "../../services/lookup/LookupService";
import {connect} from "react-redux";

class NewPatientFormRad extends Component {

    constructor(props) {
        super(props);

        this.state = {
            consentDate: new Date(),
            
            // IntakeFormRadConsent fields
            firstName: "",
            middleName: "",
            lastName: "",
            dob: "",
            age: "",
            gender: "",
            idNo: "",
            nationality: null,
            maritalStatus: null,
            religion: null,
            language: null,
            phoneNumber: "",
            whatsappNumber: null,
            email: "",
            address: "",
            country: null,
            city: "",
            postalCode: "",
            haveAllergies: "",
            allergy: {},
            howHeardAboutClinic: "",
            referringPhysician: "",
            reasonForImaging: "",
            emergencyContactName: "",
            emergencyContactRelationshipType: "",
            emergencyContactPhone: "",
            
            // Health History - Medical Conditions (Self)
            markAllSelf: "",
            asthmaSelf: "",
            tuberculosisSelf: "",
            pneumoniaSelf: "",
            covid19Self: "",
            cancerSelf: "",
            osteoarthritisSelf: "",
            osteoporosisSelf: "",
            rheumatoidArthritisSelf: "",
            thyroidDiseaseSelf: "",
            abdominalDiseasesSelf: "",
            breastDiseasesSelf: "",
            diabetesSelf: "",
            kidneyDiseaseSelf: "",
            heartDiseaseSelf: "",
            otherConditionSelf: "",

            // Health History - Medical Conditions (Family)
            markAllFamily: "",
            asthmaFamily: "",
            tuberculosisFamily: "",
            pneumoniaFamily: "",
            covid19Family: "",
            cancerFamily: "",
            osteoarthritisFamily: "",
            osteoporosisFamily: "",
            rheumatoidArthritisFamily: "",
            thyroidDiseaseFamily: "",
            abdominalDiseasesFamily: "",
            breastDiseasesFamily: "",
            diabetesFamily: "",
            kidneyDiseaseFamily: "",
            heartDiseaseFamily: "",
            otherConditionFamily: "",

            // Individual family "who" fields for each condition
            asthmaFamilyWho: null,
            tuberculosisFamilyWho: null,
            pneumoniaFamilyWho: null,
            covid19FamilyWho: null,
            cancerFamilyWho: null,
            osteoarthritisFamilyWho: null,
            osteoporosisFamilyWho: null,
            rheumatoidArthritisFamilyWho: null,
            thyroidDiseaseFamilyWho: null,
            abdominalDiseasesFamilyWho: null,
            breastDiseasesFamilyWho: null,
            diabetesFamilyWho: null,
            kidneyDiseaseFamilyWho: null,
            heartDiseaseFamilyWho: null,
            otherConditionFamilyWho: null,

            // Health History - Medications and Treatments
            onMedicationSupplements: "",
            medicationDetails: "",
            everHadSurgery: "",
            surgeryDetails: "",
            currentlyReceivingHealthcare: "",
            healthcareDetails: "",
            hadPreviousImaging: "",
            previousImagingDetails: "",
            exerciseType: "",
            smokesCurrent: "",
            smokesHistory: "",
            consumesAlcohol: "",

            // Pregnancy Related
            currentlyPregnant: "",
            lastMenstrualPeriod: "",
            lastMenstrualPeriodDetails: "",

            // Radiology-Specific Questions
            hadContrastDyeLast6Days: "",
            calciumVitaminDToday: "",
            calciumVitaminDLast24Hours: "",
            nuclearMedicineScanBariumLast6Days: "",
            dexaScanLast12Months: "",
            fastingForUltrasoundXray: "",

            // Nabidh Consent Form
            nabidhConsentAction: null,
            nabidhPatientSignature: null,
            nabidhWitnessName: "",
            nabidhWitnessSignature: null,
            nabidhRelationshipToPatient: "",

            // ConsentForInformedConsentRad fields
            pregnancyStatus: null,
            modalityType: null,
            genderAcknowledgment: null,
            witnessName: "",
            witnessSignature: "",
            providerName: "",
            providerSignature: "",
            guardianName: "",
            guardianRelationship: "",
            patientSignature: "",
            
            // State management
            componentUpdated: false
        };
    }

    componentDidMount() {
        const {patient, form} = this.props;

        RemotingService.getRemoteCall('api/appointment/first-provider/UAE/' + patient.id, {},
            (firstProvider) => {
                if (firstProvider) {
                    this.setState({providerName: firstProvider.name, providerSignature: firstProvider.signature});
                }
            });

        if (!form?.consentForIntakeFormRad) {
            let activeEmergencyContact = null;
            if (
                patient.emergencyContact &&
                patient.emergencyContact.length
            ) {
                activeEmergencyContact = patient.emergencyContact.find(
                    (emergencyContact) => emergencyContact.isActiveContact === true
                );
            }

            this.setState({
                firstName: patient.firstName ? patient.firstName : "",
                middleName: patient.middleName ? patient.middleName : "",
                lastName: patient.lastName ? patient.lastName : "",
                idNo: patient.eid ? patient.eid : "",
                gender: patient.gender ? patient.gender : "",
                dob: patient.birthday,
                nationality: patient.nationality ? patient.nationality : null,
                city: patient.cityOfResidence ? patient.cityOfResidence : "",
                email: patient.email ? patient.email : "",
                address: patient.address ? patient.address : "",
                postalCode: patient.postalCode ? patient.postalCode : "",
                phoneNumber: patient.mobilePhone ? patient.mobilePhone : "",
                emergencyContactName: activeEmergencyContact ? activeEmergencyContact.name : "",
                emergencyContactPhone: activeEmergencyContact ? activeEmergencyContact.mobilePhone : "",
            });
        }
        this.retrievePhoto();
    }

    retrievePhoto = () => {
        RemotingService.getRemoteCall(
            `api/patient/${this.props.patient.id}/document/PHOTO`,
            null,
            (dto) => {
                this.setState({photoValue: dto, newPhotoValue: dto});
            }
        );
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            JSON.stringify(this.props.form?.consentForIntakeFormRad) !==
            JSON.stringify(prevState) &&
            this.props.form?.consentForIntakeFormRad &&
            !this.state.componentUpdated
        ) {
            const formData = this.props.form.consentForIntakeFormRad;
            // When loading existing data, prioritize formData.allergy (from backend)
            // If no data from backend, preserve existing state object to maintain reference
            const allergyToUse = (formData.allergy && Object.keys(formData.allergy).length > 0)
                ? formData.allergy
                : (this.state.allergy || {});

            // Match lookup objects from Redux store for SelectInput compatibility
            const matchedFormData = this.matchLookupObjects({...formData});

            // Initialize NABIDH consent fields from backend data
            const nabidhConsent = this.props.form.nabidhConsent;
            const nabidhConsentAction = nabidhConsent?.consentType || null;

            this.setState({
                ...matchedFormData,
                allergy: allergyToUse,
                componentUpdated: true,
                // NABIDH consent fields
                nabidhConsentAction: nabidhConsentAction,
                nabidhPatientSignature: nabidhConsent?.patientSignature || null,
                nabidhWitnessName: nabidhConsent?.witnessName || "",
                nabidhWitnessSignature: nabidhConsent?.witnessSignature || null,
                nabidhRelationshipToPatient: nabidhConsent?.relationshipToPatient || ""
            });
        }
    }

    matchLookupObjects = (formData) => {
        const {relationshipTypes, nationalities, countries, maritalStatuses, religions, languages} = this.props;

        // Match emergency contact relationship type
        const relationshipTypeObject = LookupService.matchLookupObject(
            formData.emergencyContactRelationshipType,
            relationshipTypes
        );
        if (relationshipTypeObject) {
            formData.emergencyContactRelationshipType = relationshipTypeObject;
        }

        // Match nationality lookup field
        const nationalityObject = LookupService.matchLookupObject(
            formData.nationality,
            nationalities
        );
        if (nationalityObject) {
            formData.nationality = nationalityObject;
        }

        // Match country lookup field
        const countryObject = LookupService.matchLookupObject(
            formData.country,
            countries
        );
        if (countryObject) {
            formData.country = countryObject;
        }

        // Match marital status lookup field
        const maritalStatusObject = LookupService.matchLookupObject(
            formData.maritalStatus,
            maritalStatuses
        );
        if (maritalStatusObject) {
            formData.maritalStatus = maritalStatusObject;
        }

        // Match religion lookup field
        const religionObject = LookupService.matchLookupObject(
            formData.religion,
            religions
        );
        if (religionObject) {
            formData.religion = religionObject;
        }

        // Match language lookup field
        const languageObject = LookupService.matchLookupObject(
            formData.language,
            languages
        );
        if (languageObject) {
            formData.language = languageObject;
        }

        // Match family history "who" fields
        const familyWhoFields = [
            'asthmaFamilyWho', 'tuberculosisFamilyWho', 'pneumoniaFamilyWho', 'covid19FamilyWho',
            'cancerFamilyWho', 'osteoarthritisFamilyWho', 'osteoporosisFamilyWho', 'rheumatoidArthritisFamilyWho',
            'thyroidDiseaseFamilyWho', 'abdominalDiseasesFamilyWho', 'breastDiseasesFamilyWho',
            'diabetesFamilyWho', 'kidneyDiseaseFamilyWho', 'heartDiseaseFamilyWho', 'otherConditionFamilyWho'
        ];

        familyWhoFields.forEach(field => {
            if (formData[field]) {
                const matchedObject = LookupService.matchLookupObject(formData[field], relationshipTypes);
                if (matchedObject) {
                    formData[field] = matchedObject;
                }
            }
        });

        return formData;
    }

    onSubmit = () => {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        let patient = this.props.patient;
        let patientFullName = PatientUtil.getPatientName(
            patient.firstName,
            patient.middleName,
            patient.lastName
        );
        let patientMrn = StringUtil.mrn(patient.mrn);
        let patientDOB = patient.birthday;
        let patientEId = patient.eid;

        const consentForIntakeFormRad = {
            consentDate: this.state.consentDate,
            // Personal Information
            firstName: this.state.firstName,
            middleName: this.state.middleName,
            lastName: this.state.lastName,
            dob: this.state.dob,
            age: this.state.age,
            gender: this.state.gender,
            idNo: this.state.idNo,
            nationality: this.state.nationality,
            maritalStatus: this.state.maritalStatus,
            religion: this.state.religion,
            language: this.state.language,

            // Contact Information
            phoneNumber: this.state.phoneNumber,
            whatsappNumber: this.state.whatsappNumber,
            email: this.state.email,
            address: this.state.address,
            country: this.state.country,
            city: this.state.city,
            postalCode: this.state.postalCode,
            haveAllergies: this.state.haveAllergies,
            allergy: this.state.haveAllergies === "Yes" ? this.state.allergy : null,

            // Referral Information
            howHeardAboutClinic: this.state.howHeardAboutClinic,
            referringPhysician: this.state.referringPhysician,
            reasonForImaging: this.state.reasonForImaging,

            // Emergency Contact
            emergencyContactName: this.state.emergencyContactName,
            emergencyContactRelationshipType: this.state.emergencyContactRelationshipType,
            emergencyContactPhone: this.state.emergencyContactPhone,

            // Health History
            markAllSelf: this.state.markAllSelf,
            markAllFamily: this.state.markAllFamily,
            asthmaSelf: this.state.asthmaSelf,
            asthmaFamily: this.state.asthmaFamily,
            tuberculosisSelf: this.state.tuberculosisSelf,
            tuberculosisFamily: this.state.tuberculosisFamily,
            pneumoniaSelf: this.state.pneumoniaSelf,
            pneumoniaFamily: this.state.pneumoniaFamily,
            covid19Self: this.state.covid19Self,
            covid19Family: this.state.covid19Family,
            cancerSelf: this.state.cancerSelf,
            cancerFamily: this.state.cancerFamily,
            osteoarthritisSelf: this.state.osteoarthritisSelf,
            osteoarthritisFamily: this.state.osteoarthritisFamily,
            osteoporosisSelf: this.state.osteoporosisSelf,
            osteoporosisFamily: this.state.osteoporosisFamily,
            rheumatoidArthritisSelf: this.state.rheumatoidArthritisSelf,
            rheumatoidArthritisFamily: this.state.rheumatoidArthritisFamily,
            thyroidDiseaseSelf: this.state.thyroidDiseaseSelf,
            thyroidDiseaseFamily: this.state.thyroidDiseaseFamily,
            abdominalDiseasesSelf: this.state.abdominalDiseasesSelf,
            abdominalDiseasesFamily: this.state.abdominalDiseasesFamily,
            breastDiseasesSelf: this.state.breastDiseasesSelf,
            breastDiseasesFamily: this.state.breastDiseasesFamily,
            diabetesSelf: this.state.diabetesSelf,
            diabetesFamily: this.state.diabetesFamily,
            kidneyDiseaseSelf: this.state.kidneyDiseaseSelf,
            kidneyDiseaseFamily: this.state.kidneyDiseaseFamily,
            heartDiseaseSelf: this.state.heartDiseaseSelf,
            heartDiseaseFamily: this.state.heartDiseaseFamily,
            otherConditionSelf: this.state.otherConditionSelf,
            otherConditionFamily: this.state.otherConditionFamily,

            // Individual family "who" fields for each condition
            asthmaFamilyWho: this.state.asthmaFamilyWho,
            tuberculosisFamilyWho: this.state.tuberculosisFamilyWho,
            pneumoniaFamilyWho: this.state.pneumoniaFamilyWho,
            covid19FamilyWho: this.state.covid19FamilyWho,
            cancerFamilyWho: this.state.cancerFamilyWho,
            osteoarthritisFamilyWho: this.state.osteoarthritisFamilyWho,
            osteoporosisFamilyWho: this.state.osteoporosisFamilyWho,
            rheumatoidArthritisFamilyWho: this.state.rheumatoidArthritisFamilyWho,
            thyroidDiseaseFamilyWho: this.state.thyroidDiseaseFamilyWho,
            abdominalDiseasesFamilyWho: this.state.abdominalDiseasesFamilyWho,
            breastDiseasesFamilyWho: this.state.breastDiseasesFamilyWho,
            diabetesFamilyWho: this.state.diabetesFamilyWho,
            kidneyDiseaseFamilyWho: this.state.kidneyDiseaseFamilyWho,
            heartDiseaseFamilyWho: this.state.heartDiseaseFamilyWho,
            otherConditionFamilyWho: this.state.otherConditionFamilyWho,

            // Medications and Treatments
            onMedicationSupplements: this.state.onMedicationSupplements,
            medicationDetails: this.state.onMedicationSupplements !== "No" ? this.state.medicationDetails : "",
            everHadSurgery: this.state.everHadSurgery,
            surgeryDetails: this.state.everHadSurgery === "Yes" ? this.state.surgeryDetails : "",
            currentlyReceivingHealthcare: this.state.currentlyReceivingHealthcare,
            healthcareDetails: this.state.currentlyReceivingHealthcare === "Yes" ? this.state.healthcareDetails : "",
            hadPreviousImaging: this.state.hadPreviousImaging,
            previousImagingDetails: this.state.hadPreviousImaging === "Yes" ? this.state.previousImagingDetails : "",
            exerciseType: this.state.exerciseType,
            smokesCurrent: this.state.smokesCurrent,
            smokesHistory: this.state.smokesHistory,
            consumesAlcohol: this.state.consumesAlcohol,

            // Pregnancy
            currentlyPregnant: this.state.currentlyPregnant,
            lastMenstrualPeriod: this.state.currentlyPregnant === "Yes" || this.state.currentlyPregnant === "NA" ? "" : this.state.lastMenstrualPeriod,
            lastMenstrualPeriodDetails: this.state.lastMenstrualPeriod ? this.state.lastMenstrualPeriodDetails : "",

            // Radiology-Specific Questions
            hadContrastDyeLast6Days: this.state.hadContrastDyeLast6Days,
            calciumVitaminDToday: this.state.calciumVitaminDToday,
            calciumVitaminDLast24Hours: this.state.calciumVitaminDLast24Hours,
            nuclearMedicineScanBariumLast6Days: this.state.nuclearMedicineScanBariumLast6Days,
            dexaScanLast12Months: this.state.dexaScanLast12Months,
            fastingForUltrasoundXray: this.state.fastingForUltrasoundXray
        };

        const consentForInformedConsentRad = {
            consentDate: this.state.consentDate,
            pregnancyStatus: this.state.pregnancyStatus || null,
            modalityType: this.state.modalityType || null,
            genderAcknowledgment: this.state.genderAcknowledgment,
            witnessName: this.state.witnessName,
            witnessSignature: this.state.witnessSignature,
            providerName: this.state.providerName,
            providerSignature: this.state.providerSignature,
            guardianName: this.state.guardianName,
            guardianRelationship: this.state.guardianRelationship,
            patientSignature: this.state.patientSignature,
            patientFullName: patientFullName,
            patientMrn: patientMrn,
            patientDOB: patientDOB,
            patientEId: patientEId
        };

        const cancellationPolicyDxb = {
            consentDate: this.state.consentDate,
            providerName: this.state.providerName,
            guardianName: this.state.guardianName,
            guardianRelationship: this.state.guardianRelationship,
            patientSignature: this.state.patientSignature,
            patientFullName: patientFullName,
            patientMrn: patientMrn,
        };

        const nabidhConsent = {
            consentType: this.state.nabidhConsentAction,
            patientSignature: this.state.nabidhPatientSignature,
            witnessName: this.state.nabidhWitnessName,
            witnessSignature: this.state.nabidhWitnessSignature,
            relationshipToPatient: this.state.nabidhRelationshipToPatient,
            patientFullName: patientFullName,
            patientMrn: patientMrn,
            patientDOB: patientDOB
        };

        RemotingService.postRemoteCall(
            "api/patient/" + this.props.patient.id + "/new-patient-form-rad",
            {consentForIntakeFormRad, consentForInformedConsentRad, cancellationPolicyDxb, nabidhConsent},
            (result) => {
                this.props.afterSave(result);
                this.props.close();
            }
        );
    };

    fieldChanged = (fieldName, value, validationCallback) => {
        this.setState({[fieldName]: value}, () => {
            if (validationCallback) {
                validationCallback(this);
            }
        });
    };

    fieldGroupChanged = (fieldGroupObject, value, validationCallback) => {
        this.setState(fieldGroupObject, () => {
            if (validationCallback) {
                validationCallback(this);
            }
        });
    };

    onSavePatientSignature = (signature) => {
        this.setState({patientSignature: signature});
    };

    onSaveWitnessSignature = (signature) => {
        this.setState({witnessSignature: signature});
    };

    onSaveNabidhPatientSignature = (signature) => {
        this.setState({nabidhPatientSignature: signature});
    };

    onSaveNabidhWitnessSignature = (signature) => {
        this.setState({nabidhWitnessSignature: signature});
    };

    handleNabidhConsentActionChange = (value) => {
        this.setState({nabidhConsentAction: value});
    };

    isFormReadonly = (form) => {
        if (!form) return false;
        return form?.consentForIntakeFormRad &&
            form?.consentForInformedConsentRad &&
            form?.cancellationPolicyDxb;
    }

    pushFormFieldRef = (ref) => this.formFields.push(ref);

    render() {
        if (!this.props.show) return null;
        const {patient, form} = this.props;
        const readOnly = this.isFormReadonly(form);
        const mrnNo = StringUtil.mrn(patient.mrn);
        const selectedLanguage = this.props.selectedLanguage.name;
        const patientName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
        this.formFields = [];

        const photoValue = this.state.photoValue;
        const photoSrc = photoValue
            ? `data:image/jpeg;base64,${photoValue.content}`
            : `${process.env.PUBLIC_URL}/assets/patient_profile.png`;

        const formBodyClass = this.props.selectedLanguage == FormLanguages.ARABIC ? "arabic-form" : "";
        const maxWidthClass = "form-body";
        const enumLabel = this.props.selectedLanguage == FormLanguages.ARABIC ? "nameInArabic" : "name";
        const nationalityLabel = this.props.selectedLanguage == FormLanguages.ARABIC ? "nameInArabic" : "nameInEnglish";
        const commonProps = {
            selectedLanguage,
            enumLabel,
            nationalityLabel,
            readOnly,
            onChange: this.fieldChanged,
            onFieldGroupChanged: this.fieldGroupChanged,
            formFields: this.formFields,
            pushFormFieldRef: this.pushFormFieldRef
        }

        const commonInformedConsentProps = {
            selectedLanguage,
            pushFormFieldRef: this.pushFormFieldRef
        }

        return (
            <Wizard
                className="WizardModal"
                show={this.props.show}
                close={this.props.close}
                title={IntakeFormRadTextEnum.New_Patient_Form_Rad_Header[selectedLanguage]}
                onSubmit={this.onSubmit}
                isReadOnly={readOnly}
                previousBtnText={IntakeFormRadTextEnum.Wizard_Previous[selectedLanguage]}
                nextBtnText={IntakeFormRadTextEnum.Wizard_Next[selectedLanguage]}
                saveBtnText={IntakeFormRadTextEnum.Wizard_Save[selectedLanguage]}
            >
                {/* Page 1: Personal & Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}>
                    <div className={`${readOnly ? "TextInputDisabled" : ""}`} style={{width: "1000px"}}>
                        <IntakeFormHeader {...commonProps}
                                          photoSrc={photoSrc}
                                          mrnNo={mrnNo}
                                          consentDate={this.state.consentDate}
                                          title={IntakeFormRadTextEnum.New_Patient_Form_Rad_Title[selectedLanguage]}
                        />

                        <div className={formBodyClass}>
                            <IntakeFormRadPersonalInformation {...commonProps}
                                                              firstName={this.state.firstName}
                                                              middleName={this.state.middleName}
                                                              lastName={this.state.lastName}
                                                              dob={this.state.dob}
                                                              age={this.state.age}
                                                              gender={this.state.gender}
                                                              idNo={this.state.idNo}
                                                              nationality={this.state.nationality}
                                                              nationalities={this.props.nationalities}
                                                              maritalStatus={this.state.maritalStatus}
                                                              maritalStatuses={this.props.maritalStatuses}
                                                              religion={this.state.religion}
                                                              religions={this.props.religions}
                                                              language={this.state.language}
                                                              languages={this.props.languages}
                                                              haveAllergies={this.state.haveAllergies}
                                                              allergy={this.state.allergy}
                                                              allergyTypes={this.props.allergyTypes}
                                                              allergenTypes={this.props.allergenTypes}
                                                              allergySeverities={this.props.allergySeverities}
                                                              allergenReactionTypes={this.props.allergenReactionTypes}
                                                              onAllergyChanged={() => {
                                                                  const allergy = this.state.allergy;
                                                                  this.setState({allergy: {...allergy, items: [...(allergy.items || [])]}});
                                                              }}
                            />

                            <IntakeFormRadContactInformation {...commonProps}
                                                             phoneNumber={this.state.phoneNumber}
                                                             whatsappNumber={this.state.whatsappNumber}
                                                             email={this.state.email}
                                                             address={this.state.address}
                                                             country={this.state.country}
                                                             countries={this.props.countries}
                                                             city={this.state.city}
                                                             postalCode={this.state.postalCode}
                            />
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 2: Referral & Emergency Contact Information */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadReferralInformation {...commonProps}
                                                          howHeardAboutClinic={this.state.howHeardAboutClinic}
                                                          referringPhysician={this.state.referringPhysician}
                                                          reasonForImaging={this.state.reasonForImaging}
                        />

                        <IntakeFormRadEmergencyContact {...commonProps}
                                                       emergencyContactName={this.state.emergencyContactName}
                                                       emergencyContactRelationshipType={this.state.emergencyContactRelationshipType}
                                                       emergencyContactPhone={this.state.emergencyContactPhone}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 3: Health History */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={formBodyClass + " my-2"} style={{width: "1000px"}}>
                        <IntakeFormRadHealthHistory {...commonProps}
                                                    markAllSelf={this.state.markAllSelf}
                                                    markAllFamily={this.state.markAllFamily}
                                                    asthmaSelf={this.state.asthmaSelf}
                                                    asthmaFamily={this.state.asthmaFamily}
                                                    tuberculosisSelf={this.state.tuberculosisSelf}
                                                    tuberculosisFamily={this.state.tuberculosisFamily}
                                                    pneumoniaSelf={this.state.pneumoniaSelf}
                                                    pneumoniaFamily={this.state.pneumoniaFamily}
                                                    covid19Self={this.state.covid19Self}
                                                    covid19Family={this.state.covid19Family}
                                                    cancerSelf={this.state.cancerSelf}
                                                    cancerFamily={this.state.cancerFamily}
                                                    osteoarthritisSelf={this.state.osteoarthritisSelf}
                                                    osteoarthritisFamily={this.state.osteoarthritisFamily}
                                                    osteoporosisSelf={this.state.osteoporosisSelf}
                                                    osteoporosisFamily={this.state.osteoporosisFamily}
                                                    rheumatoidArthritisSelf={this.state.rheumatoidArthritisSelf}
                                                    rheumatoidArthritisFamily={this.state.rheumatoidArthritisFamily}
                                                    thyroidDiseaseSelf={this.state.thyroidDiseaseSelf}
                                                    thyroidDiseaseFamily={this.state.thyroidDiseaseFamily}
                                                    abdominalDiseasesSelf={this.state.abdominalDiseasesSelf}
                                                    abdominalDiseasesFamily={this.state.abdominalDiseasesFamily}
                                                    breastDiseasesSelf={this.state.breastDiseasesSelf}
                                                    breastDiseasesFamily={this.state.breastDiseasesFamily}
                                                    diabetesSelf={this.state.diabetesSelf}
                                                    diabetesFamily={this.state.diabetesFamily}
                                                    kidneyDiseaseSelf={this.state.kidneyDiseaseSelf}
                                                    kidneyDiseaseFamily={this.state.kidneyDiseaseFamily}
                                                    heartDiseaseSelf={this.state.heartDiseaseSelf}
                                                    heartDiseaseFamily={this.state.heartDiseaseFamily}
                                                    otherConditionSelf={this.state.otherConditionSelf}
                                                    otherConditionFamily={this.state.otherConditionFamily}

                                                    asthmaFamilyWho={this.state.asthmaFamilyWho}
                                                    tuberculosisFamilyWho={this.state.tuberculosisFamilyWho}
                                                    pneumoniaFamilyWho={this.state.pneumoniaFamilyWho}
                                                    covid19FamilyWho={this.state.covid19FamilyWho}
                                                    cancerFamilyWho={this.state.cancerFamilyWho}
                                                    osteoarthritisFamilyWho={this.state.osteoarthritisFamilyWho}
                                                    osteoporosisFamilyWho={this.state.osteoporosisFamilyWho}
                                                    rheumatoidArthritisFamilyWho={this.state.rheumatoidArthritisFamilyWho}
                                                    thyroidDiseaseFamilyWho={this.state.thyroidDiseaseFamilyWho}
                                                    abdominalDiseasesFamilyWho={this.state.abdominalDiseasesFamilyWho}
                                                    breastDiseasesFamilyWho={this.state.breastDiseasesFamilyWho}
                                                    diabetesFamilyWho={this.state.diabetesFamilyWho}
                                                    kidneyDiseaseFamilyWho={this.state.kidneyDiseaseFamilyWho}
                                                    heartDiseaseFamilyWho={this.state.heartDiseaseFamilyWho}
                                                    otherConditionFamilyWho={this.state.otherConditionFamilyWho}

                                                    onMedicationSupplements={this.state.onMedicationSupplements}
                                                    medicationDetails={this.state.medicationDetails}
                                                    everHadSurgery={this.state.everHadSurgery}
                                                    surgeryDetails={this.state.surgeryDetails}
                                                    currentlyReceivingHealthcare={this.state.currentlyReceivingHealthcare}
                                                    healthcareDetails={this.state.healthcareDetails}
                                                    hadPreviousImaging={this.state.hadPreviousImaging}
                                                    previousImagingDetails={this.state.previousImagingDetails}
                                                    exerciseType={this.state.exerciseType}
                                                    smokesCurrent={this.state.smokesCurrent}
                                                    smokesHistory={this.state.smokesHistory}
                                                    consumesAlcohol={this.state.consumesAlcohol}
                                                    currentlyPregnant={this.state.currentlyPregnant}
                                                    lastMenstrualPeriod={this.state.lastMenstrualPeriod}
                                                    lastMenstrualPeriodDetails={this.state.lastMenstrualPeriodDetails}
                                                    hadContrastDyeLast6Days={this.state.hadContrastDyeLast6Days}
                                                    calciumVitaminDToday={this.state.calciumVitaminDToday}
                                                    calciumVitaminDLast24Hours={this.state.calciumVitaminDLast24Hours}
                                                    nuclearMedicineScanBariumLast6Days={this.state.nuclearMedicineScanBariumLast6Days}
                                                    dexaScanLast12Months={this.state.dexaScanLast12Months}
                                                    fastingForUltrasoundXray={this.state.fastingForUltrasoundXray}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 4: Informed Consent for Radiology */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <ConsentFormPartsRad.Title selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.RadiologyProcedureConsent selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.ModalityTypeSelection
                            {...commonInformedConsentProps}
                            modalityType={readOnly ? form.consentForInformedConsentRad.modalityType : this.state.modalityType}
                            readOnly={readOnly}
                            formFields={this.formFields}
                            onChange={this.fieldChanged}
                        />
                        <ConsentFormPartsRad.RadiationRiskDeclaration
                            {...commonInformedConsentProps}
                            pregnancyStatus={readOnly ? form.consentForInformedConsentRad.pregnancyStatus : this.state.pregnancyStatus}
                            readOnly={readOnly}
                            formFields={this.formFields}
                            onChange={this.fieldChanged}
                        />
                        <ConsentFormPartsRad.RemoteRadiologyConsent selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.DataCollectionAndPrivacy selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.PatientRights selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.QuestionsAndConcerns selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.Complaints selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.FinalConsent selectedLanguage={selectedLanguage}/>
                        <ConsentFormPartsRad.HealthcareProviderGenderAcknowledgment 
                            selectedLanguage={selectedLanguage}
                            genderAcknowledgment={readOnly ? form.consentForInformedConsentRad.genderAcknowledgment : this.state.genderAcknowledgment}
                            onGenderAcknowledgmentChange={(value) => this.fieldChanged("genderAcknowledgment", value)}
                            readOnly={readOnly}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />

                        <div>
                            <InformedConsentSignatureInputs {...commonInformedConsentProps}
                                                            readOnly={readOnly}
                                                            formFields={this.formFields}
                                                            textEnum={InformedConsentFormRadTextEnum}
                                                            consentDate={moment(readOnly ? new Date(form.consentForInformedConsentRad.consentDate) : this.state.consentDate).format('LL')}
                                                            patientName={patientName}
                                                            providerName={readOnly ? form.consentForInformedConsentRad.providerName : this.state.providerName}
                                                            guardianName={readOnly ? form.consentForInformedConsentRad.guardianName : this.state.guardianName}
                                                            guardianRelationship={readOnly ? form.consentForInformedConsentRad.guardianRelationship : this.state.guardianRelationship}
                                                            patientSignature={readOnly ? form.consentForInformedConsentRad.patientSignature : this.state.patientSignature}
                                                            providerSignature={readOnly ? form.consentForInformedConsentRad.providerSignature : this.state.providerSignature}
                                                            onSavePatientSignature={this.onSavePatientSignature}
                                                            onChange={this.fieldChanged}/>
                        </div>

                        <ConsentFormPartsRad.WitnessStatement 
                            selectedLanguage={selectedLanguage}
                            consentDate={moment(readOnly ? new Date(form.consentForInformedConsentRad.consentDate) : this.state.consentDate).format('LL')}
                            witnessName={readOnly ? form.consentForInformedConsentRad.witnessName : this.state.witnessName}
                            witnessSignature={readOnly ? form.consentForInformedConsentRad.witnessSignature : this.state.witnessSignature}
                            onWitnessNameChange={(value) => this.fieldChanged("witnessName", value)}
                            onWitnessSignatureChange={this.onSaveWitnessSignature}
                            readOnly={readOnly}
                            formFields={this.formFields}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />
                    </div>
                </Wizard.Page>

                {/* Page 5: Cancellation Policy */}
                <Wizard.Page 
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <h3 className="text-center mb-4">
                            <b>{CancellationPolicyDxbTextEnum.Cancellation_Policy_Public_Title[selectedLanguage]}</b>
                        </h3>
                        <CancellationPolicyPartsDxb.Part1 selectedLanguage={selectedLanguage}/>
                        <div style={{border: "1px solid #000000", borderRadius: "35px"}}>
                            <CancellationPolicyPartsDxb.Part2 selectedLanguage={selectedLanguage}/>
                        </div>
                        <div className="mt-4">
                            <CancellationPolicyPartsDxb.Part3 selectedLanguage={selectedLanguage}
                                                              patientName={patientName}/>
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 6: NABIDH Consent Form - Information & Patient Signature */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div className={`${formBodyClass} ${maxWidthClass}`}>
                        <h3 className="text-center mb-4">
                            <b>{NabidhFormTextEnum.Nabidh_Consent_Form_Title[selectedLanguage]}</b>
                        </h3>
                        <NabidhConsentFormParts.PatientInformation
                            selectedLanguage={selectedLanguage}
                            patientName={patientName}
                            mrnNo={mrnNo}
                            patientDOB={patient.birthday}
                        />
                        <NabidhConsentFormParts.NabidhInformation selectedLanguage={selectedLanguage}/>

                        <NabidhConsentFormParts.PatientSignatureSection
                            selectedLanguage={selectedLanguage}
                            readOnly={readOnly}
                            consentDate={readOnly ? new Date(form.nabidhConsent?.consentDate || this.state.consentDate) : this.state.consentDate}
                            patientName={patientName}
                            patientSignature={readOnly ? form.nabidhConsent?.patientSignature : this.state.nabidhPatientSignature}
                            onSavePatientSignature={this.onSaveNabidhPatientSignature}
                            pushFormFieldRef={this.pushFormFieldRef}
                        />
                    </div>
                </Wizard.Page>

            </Wizard>
        );
    }
}

function mapStateToProps(state) {
    return {
        nationalities: state.base.lookupNationalities,
        countries: state.base.lookupCountries,
        relationshipTypes: state.base.relationshipTypes,
        maritalStatuses: state.base.lookupMaritalStatuses,
        religions: state.base.lookupReligions,
        languages: state.base.lookupLanguages,
        allergyTypes: state.base.allergyTypes,
        allergenTypes: state.base.allergenTypes,
        allergySeverities: state.base.allergySeverities,
        allergenReactionTypes: state.base.allergenReactionTypes
    };
}

export default connect(mapStateToProps)(NewPatientFormRad);